import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';

import styles from './TeamOnboardingPupTooltip.less';

const format = forNamespace(['team onboarding', 'power-up-dialog']);

interface TeamOnboardingPupTooltipProps {
  onDismiss(): void;
}

export const TeamOnboardingPupTooltip: React.FunctionComponent<TeamOnboardingPupTooltipProps> = ({
  onDismiss,
}) => {
  return (
    <div className={styles.pupTooltip}>
      <h3>{format('find-more')}</h3>
      <p>{format('find-more-description')}</p>
      <button className={styles.pupTooltipDismiss} onClick={onDismiss}>
        {format('dismiss')}
      </button>
    </div>
  );
};
